export const GET_COORDINATOR_REGISTERED_EXAM = 'GET_REGISTERED_EXAM';
export const GET_EXAM_LEVELS = 'GET_EXAM_LEVELS';
export const POST_CHECK_EXAM_LEVELS = 'POST_CHECK_EXAM_LEVELS';
export const GET_EXAM_LEVEL_BY_CODE = 'GET_EXAM_LEVEL_BY_CODE';
export const POST_CREATE_WITHDRAWAL = 'POST_CREATE_WITHDRAWAL';
export const GET_WITHDRAWAL_SUMMARY = 'GET_WITHDRAWAL_SUMMARY';
export const GET_WITHDRAWAL_SELECTED_REASON = 'GET_WITHDRAWAL_SELECTED_REASON';
export const PUT_WITHDRAWAL_REASON = 'PUT_WITHDRAWAL_REASON';
export const GET_WITHDRAWALS = 'GET_WITHDRAWALS';
export const DELETE_GROUP_REGISTRATION = 'DELETE_GROUP_REGISTRATION';
export const POST_CANDIDATES = 'POST_CANDIDATES';
export const GET_WITHDRAWALS_SUMMARY = 'GET_WITHDRAWALS_SUMMARY';
export const PUT_CONFIRM_WITHDRAWAL = 'PUT_CONFIRM_WITHDRAWAL';
export const POST_SEARCH_WITHDRAWAL_CANDIDATES = 'POST_SEARCH_WITHDRAWAL_CANDIDATES';
export const POST_ADDED_CANDIDATES = 'POST_ADDED_CANDIDATES';
export const DELETE_ADDED_CANDIDATES = 'DELETE_ADDED_CANDIDATES';
export const GET_WITHDRAWAL_RESULT = 'GET_WITHDRAWAL_RESULT';
export const GET_WITHDRAWAL_PDF = 'GET_WITHDRAWAL_PDF';
